export default __webpack_public_path__ + "static/media/youtube.f750ec57.svg";